import { render, staticRenderFns } from "./IndustryNewsModule.vue?vue&type=template&id=47f28ff0&scoped=true"
import script from "./IndustryNewsModule.vue?vue&type=script&lang=js"
export * from "./IndustryNewsModule.vue?vue&type=script&lang=js"
import style0 from "./IndustryNewsModule.vue?vue&type=style&index=0&id=47f28ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f28ff0",
  null
  
)

export default component.exports